export const ADMIN_CLIENT = 'admin_client';
export const OEM_CLIENT = 'oem_client';
export const LANG_JP = 'jp';
export const LANG_EN = 'en';
export const COUNTRY_CODE_JP = 'JP';
export const LOCAL_AREA_COMMON = 'common';
export const LOCAL_AREA_PREFECTURES = 'prefectures';
export const LOCAL_AREA_CITIES = 'cities';
export const LOCAL_AREA_STATIONS = 'stations';
export const PREFECTURE_TYPE = 1;
export const CITY_TYPE = 2;
export const STATION_TYPE = 3;
export const REQUIRED_SERVICE_ID_BACKLINK = 1;
export const REQUIRED_SERVICE_ID_ARTICLE = 2;
export const REQUIRED_SERVICE_ID_INF_DB = 3;
export const REQUIRED_SERVICE_ID_REVIEW_PROMOTION = 4;

export const SYSTEM_ENV_LOCAL = 'local';
export const SYSTEM_ENV_DEV = 'dev';
export const SYSTEM_ENV_STG = 'stg';
export const SYSTEM_ENV_PROD = 'prod';
